import React, {useEffect, useState} from 'react'
import {BasicLayout} from '../../../modules/Layouts/basicLayout'
import CardMenu from '../../../components/CardMenu/CardMenu'
import {Link, useHistory} from 'react-router-dom'
import DarkAgregarUsuario from '../../../media/felsv/DarkAgregarUsuario.svg'
import WhiteAgregarUsuario from '../../../media/felsv/WhiteAgregarUsuario.svg'
import DarkUsuarios from '../../../media/felsv/dark_users_icon.svg'
import WhiteUsuario from '../../../media/felsv/white_users_icon.svg'
import {KEYS} from '../../../constants/keysStorage'

const GCDashboard = () => {
  const [activo, setActivo] = useState(0)
  const history = useHistory()

  useEffect(() => {
    window.scroll(0, 0)
    let rol = localStorage.getItem(KEYS.ROL)?.toString() || '0'
    if (rol !== '2') {
      history.push('/home')
    }
  }, [])

  return (
    <BasicLayout>
      <div className='header-link'>
        <Link to='/home' className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Gestión de clientes</h3>
      </div>
      <div className='separador'></div>
      <div className='home-dashboard wf-layout-layout flex flex-col w-full'>
        <div className='home-dashboard wf-layout-layout'>
          <CardMenu
            to='/gestion-clientes/agregar-cliente'
            activar={() => setActivo(1)}
            desactivar={() => setActivo(0)}
            activo={activo === 1}
            WhiteIcon={WhiteAgregarUsuario}
            DarkIcon={DarkAgregarUsuario}
            title='Agregar cliente'
            description='Agregar nuevos clientes de forma manual o mediante carga masiva'
            autoFocus={true}
          />
          <CardMenu
            to='/gestion-clientes/listar-clientes'
            activar={() => setActivo(2)}
            desactivar={() => setActivo(0)}
            activo={activo === 2}
            WhiteIcon={WhiteUsuario}
            DarkIcon={DarkUsuarios}
            title='Lista de clientes'
            description='Consultar, editar y gestionar el estado de los clientes registrados'
          />
        </div>
      </div>
    </BasicLayout>
  )
}

export default GCDashboard
